/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Mode_IntervalInputs */

const vi_irrigation_schedule_mode_interval = /** @type {(inputs: Irrigation_Schedule_Mode_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chu kỳ`)
};

/**

* @param {Irrigation_Schedule_Mode_IntervalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_mode_interval = /** @type {((inputs?: Irrigation_Schedule_Mode_IntervalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Mode_IntervalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_mode_interval(inputs)
});